// removed by extract-text-webpack-plugin
module.exports = {"block":"_2PXSBpYP8slj9dGG_p2YXA","zebra":"yx4J7NAzlIXTIdsfIRJea","zebraBlue":"P1SKzuN-wIlOo1wUglJ2o","list":"_3tyIym16hMWqzM5dNeunzB","yellow":"_1jupAlnQCdsitU95OHX2uw","darkgray":"_1OVcYv3b53-9UHAG9Aesq7","wrapper":"_3n36rz02uunsqqB1iktDfG","heading":"_1aLIzamht1Ydefl04cCMcX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfographicListBlock/InfographicListBlock.module.scss
// module id = 780
// module chunks = 0